import {
	Card,
	CardContent,
	CardHeader,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from '@mui/material';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { IControlQualityCheck } from 'common/api/type-def';
import {
	AiRecipePageTitle,
	AI_SIMULATION_TYPES,
	AI_TYPE,
} from 'common/constants/AISimulationConstants';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import {
	setAIModelDetail,
	setAIRecipeDetail,
	setControlQuality,
	setSelectedRecipe,
	setWorkflowFeedback,
} from 'common/store/reducer/simulationReducer';
import {
	toSentenceCase,
	truncateString,
	urlWithTenant,
} from 'common/utils/utilFunctions';

import {
	IAICard,
	IAIModelDetails,
	IAIRecipeDetails,
} from 'features/AiSimulation/api/type-def';

import aiCardStyles from './AICard.module.scss';

const { OBLIGATION_TO_POLICY, PLAIN_ENGLISH_SUMMARY, REGULATION_SUMMARY } =
	AI_SIMULATION_TYPES;
const { MODEL, RECIPE } = AI_TYPE;

const AICard = (props: IAICard) => {
	const { icon, key, data, type, path, title, children, onClickHandler } =
		props;

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const navigateToPath = () => {
		const updatedPath = `/${rrcpDashboardRoutes.simulationArena}/${path}`;
		dispatch(setWorkflowFeedback([]));
		dispatch(setControlQuality({} as IControlQualityCheck));
		if (path) {
			if (type === RECIPE) {
				dispatch(setAIRecipeDetail(data as IAIRecipeDetails));
			}
			if (type === MODEL) {
				dispatch(setAIModelDetail(data as IAIModelDetails));
			}
			navigate(path ? urlWithTenant(updatedPath) : '');
			if (
				title === toSentenceCase(OBLIGATION_TO_POLICY) ||
				title === PLAIN_ENGLISH_SUMMARY ||
				title === REGULATION_SUMMARY ||
				title === AiRecipePageTitle
			) {
				dispatch(setSelectedRecipe(title));
			}
		} else if (onClickHandler) {
			onClickHandler(data);
		}
	};

	return (
		<Card
			key={key}
			className={`${aiCardStyles['aicard-container']} ${
				aiCardStyles[icon ? 'aicard-height' : '']
			}`}
			onClick={navigateToPath}
		>
			<CardHeader
				className={aiCardStyles['aicard-header']}
				title={
					<Stack
						direction="row"
						className={aiCardStyles['aicard-title-container']}
					>
						<IconButton className={aiCardStyles['aicard-icon']} disableRipple>
							{icon}
						</IconButton>
						{title?.length > 100 ? (
							<Tooltip title={title}>
								<Typography className={aiCardStyles['aicard-title']}>
									<span>{`${truncateString(title, 100)}...`}</span>
								</Typography>
							</Tooltip>
						) : (
							<Typography className={aiCardStyles['aicard-title']}>
								{title}
							</Typography>
						)}
					</Stack>
				}
			/>
			<CardContent className={aiCardStyles['aicard-content']}>
				{children}
			</CardContent>
		</Card>
	);
};

export default AICard;
